import React from "react";
import { WHY } from "@/data/content";
import { Reveal, MaskedLinesInView } from "./Motion";

const WhyUs = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-6">{WHY.overline}</p>
        </Reveal>
        <h2 className="font-serif tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl max-w-4xl">
          <MaskedLinesInView lines={[WHY.heading]} className="text-white" />
          <MaskedLinesInView lines={[WHY.headingAccent]} lineClassName="italic text-gold-gradient" delay={0.1} />
        </h2>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/[0.06] rounded-3xl overflow-hidden border border-white/[0.06]">
          {WHY.points.map((p, i) => (
            <Reveal key={p.no} delay={i * 0.08}>
              <div
                data-testid={`why-card-${p.no}`}
                className="group relative bg-ink-surface/40 hover:bg-ink-surface transition-colors duration-500 p-8 md:p-12 h-full"
              >
                <div className="flex items-start justify-between gap-6">
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-white mb-4 tracking-tight">
                      {p.title}
                    </h3>
                    <p className="text-sm md:text-base text-white/55 leading-relaxed max-w-md">
                      {p.body}
                    </p>
                  </div>
                  <span className="font-serif text-5xl md:text-6xl leading-none text-outline shrink-0 transition-all duration-500 group-hover:text-gold/25">
                    {p.no}
                  </span>
                </div>
                <div className="mt-8 h-px w-0 group-hover:w-full bg-gradient-to-r from-gold/60 to-transparent transition-all duration-700" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
